import groupBy from 'lodash/groupBy'

import { PaginatedTableItem, SUMMARIZED_VALUES, TableItemData } from '../types/table'

export const regroupedItemsByCategory = (items: PaginatedTableItem[]) => {
  const grouped = groupBy(items, 'categoryLabel')

  return Object.entries(grouped)
    .map(([categoryLabel, groupItems]) => {
      const aggregatedData: Record<string, TableItemData> = {}
      const isUngrouped = groupItems.some((item) => !item.category)
      const isSummarized = groupItems.some((item) => item.category === SUMMARIZED_VALUES)
      groupItems.forEach((item) => {
        item.data.forEach(({ label, period, range, totalAmountInCents }) => {
          const existing = aggregatedData[label] ?? {
            label,
            period,
            range,
            totalAmountInCents: '0',
          }

          aggregatedData[label] = {
            ...existing,
            isUngrouped,
            isSummarized,
            totalAmountInCents:
              isSummarized || isUngrouped
                ? '0'
                : (Number(existing.totalAmountInCents) + Number(totalAmountInCents)).toString(),
          }
        })
      })

      return {
        isUngrouped,
        isSummarized,
        id: categoryLabel,
        label: categoryLabel,
        data: Object.values(aggregatedData),
        children: groupItems.map((item) => {
          return {
            ...item,
            isUngrouped,
            isSummarized,
            categoryLabel: undefined,
          }
        }),
      }
    })
    .sort((a, b) => {
      // Ensure the group whose children contain an item with no category or category === SUMMARIZED_VALUES is always placed last
      const bIsUngrouped = b.children.every((child) => !child.category)
      const aIsUngrouped = a.children.every((child) => !child.category)
      const aIsSummarized = a.children.some((child) => child.category === SUMMARIZED_VALUES)
      const bIsSummarized = b.children.some((child) => child.category === SUMMARIZED_VALUES)
      if (bIsUngrouped && aIsSummarized) return 1
      if (aIsUngrouped && bIsSummarized) return -1

      if (aIsUngrouped && !bIsUngrouped) return 1
      if (!aIsUngrouped && bIsUngrouped) return -1

      if (aIsSummarized && !bIsSummarized) return 1
      if (!aIsSummarized && bIsSummarized) return -1
      return 0
    })
}
